import { Component, AfterViewInit } from '@angular/core';
import { PageFlags } from './shared/models/pageFlags.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  title = 'emju-web-ui';
  public pageFlags: PageFlags = {
    isBonusPathPage: false,
    isCouponsDealsPage: false,
    isOfferDetailsPage: false,
    isDiscoveryPage: true
  };
  public displaySection: boolean = false;
  /**
   * Indicates whether the application is being viewed on a small screen device.
   * Typically used to adjust UI layout or behavior for responsive design.
   */
  public smallScreen!: boolean;
  public isBonusPath!: boolean;

  constructor(public router: Router) {

  }

  ngAfterViewInit(): void {
    // Signal to the AEM shell that Angular's component tree is ready.
    // revealFooterWhenReady() in the shell HTML listens for this event and
    // then waits for app-root to extend below the viewport before setting
    // div#footer display:block — guaranteeing zero CLS from footer reveal.
    (window as any)['_appContentReady'] = true;
    window.dispatchEvent(new CustomEvent('appContentReady'));
  }

}
